import InputLabel from "@material-ui/core/InputLabel";
export default InputLabel;

export let styles = theme => ({
  root: {
    fontSize: "14px"
  },
  formControl: {
    transform: "translate(0, 26px)"
  },
  asterisk: {
    color: theme.palette.common.danger
  },
  outlined: {
    transform: "translate(8px, 30px)",
    "&.MuiInputLabel-shrink": {
      transform: "translate(8px, 0)"
    }
  },
  shrink: {
    transform: "translate(0, 0)"
  }
});
